import { ReactNode } from 'react'

import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import TickRegularIcon from 'shared/icons/tick_regular.svg'
import { Paper } from 'shared/ui/paper'

import { Option } from '../../select'

import styles from './styles.module.scss'

interface OptionItem extends Option {
  prefix?: ReactNode
}

interface Props {
  value?: Option
  listOption?: OptionItem[]
  onChange?: (name: Option) => void
  buttonText?: string
}

export const BlockSelect = ({ value, onChange, listOption }: Props) => {
  const { t } = useTranslation()
  const onClickHandler = (name: Option) => {
    onChange?.(name)
  }

  return (
    <div>
      <Paper padding={[0]}>
        <div className={styles.wrapperOptions}>
          {listOption?.map((item, index) => (
            <div
              key={'option' + item.name + index}
              onClick={() => onClickHandler(item)}
              className={clsx(styles.option)}
            >
              <div className={styles.left}>
                {item?.prefix && item.prefix}

                <span className={styles.name}> {t(item?.name)} </span>
              </div>

              <div className={styles.indicator}>
                {value?.value === item.value ? (
                  <div className={styles.activeRadio}>
                    <img
                      src={TickRegularIcon}
                      alt=""
                    />
                  </div>
                ) : (
                  <div className={styles.unActiveRadio} />
                )}
              </div>
            </div>
          ))}
        </div>
      </Paper>
    </div>
  )
}
